import React from 'react';
import {FiFacebook, FiTwitter,FiInstagram} from 'react-icons/fi'
import { images } from '../../constants';
import {motion} from 'framer-motion'


import { Newsletter } from '../../components';

import './Footer.css';

const Footer = () => (
  <div className='footer w-full   m-h-screen flex justify-center items-start bg-[#0c0c0c] relative'>
    <div className="w-[80%] mt-32 flex flex-col items-center justify-center m-auto px-4">
      
      <Newsletter />


      <div className="footer flex flex-col md:flex-row justify-between items-center mb-12 gap-5">
        <motion.div
        whileInView={{x:[-100, 0], opacity: [0,1]}}
        transition={{duration: 0.8, type: "spring"}}
        
         className="links-con w-full text-center mt-8 md:basis[33.33%] basis-[100%]">
          <h1 className='text-white text-3xl mb-4'>Contact Us</h1>
          <p className='text-white mb-4'>9 W 53rd St, New York , NY 10019, USA</p>
          <p  className='text-white'>+1 212-344-1230</p>
          <p className='text-white'>+1 212-555-1230</p>
        </motion.div>
        <motion.div 
         whileInView={{x:[100, 0], opacity: [0,1]}}
        transition={{duration: 0.8, type: "spring"}}
        className="righ text-center place-items-center flex flex-col mt-8 md:basis[33.33%] basis-[100%]">
              <img src={images.gericht} alt="" className='' />
              <p className='mb-4 text-white'>The best way to find yourself is to lose yourself in the service of other.</p>
              <img src={images.spoon} alt="" className='w-3rem'/>
              <div className="social flex flex-row gap-2 mt-4">
                <FiFacebook  className='text-white text-3xl cursor-pointer duration-300 hover:scale-110'  styles={{color: "white", fontSize: "25px"}} />
                <FiTwitter   className='text-white text-3xl cursor-pointer duration-300 hover:scale-110' styles={{color: "white", fontSize: "25px"}} />
                <FiInstagram  className='text-white text-3xl cursor-pointer duration-300 hover:scale-110'  styles={{color: "white", fontSize: "25px"}} />
              </div>
        </motion.div>
        <motion.div 
         whileInView={{x:[-100, 0], opacity: [0,1]}}
        transition={{duration: 0.8, type: "spring"}}
        className="last md:basis[33.33%] basis-[100%] text-center mt-8">
        <h1 className='text-white text-3xl mb-4'>Working Hours</h1>
          <p className='text-white mb-4'>Monday-Friday</p>
          <p  className='text-white mb-4'>04:00 am - 12:00 pm</p>
          <p className='text-white'>Saturday-Sunday</p>
          <p className='text-white'>07:00 am-11:00 pm</p>
        </motion.div>
      </div>
      <div className="bot mb-4">
        <p className='text-white'>2021 Gericht, All Rights reserved</p>
      </div>


    </div>
  </div>
);

export default Footer;
